import { ATUALIZA_HORARIO } from '../horario/types'
import { ATUALIZA_PACIENTE } from '../paciente/types'
import { ATUALIZA_PAGAMENTO } from '../pagamento/types'
import { Consulta } from '../../models/Consulta'
import { ATUALIZA_ESPECIALIDADE } from '../especialidade/types'
import { ATUALIZA_MEDICO } from '../medico/types'
import {
  START_CONSULTA,
  ATUALIZA_ESCOLHA,
  ATUALIZA_MODALIDADE_ATENDIMENTO,
  LIMPA_CONSULTA,
  REINICIA_CONSULTA,
  ATUALIZA_NUMERO_REQUISICAO,
  ATUALIZA_CONFIRMACAO,
  ATUALIZA_ORIGEM_TELECONSULTA,
  ATUALIZA_LOCAL_SUGESTOES,
  LIMPA_LOCAL_SUGESTOES,
  ATUALIZA_FALLBACK_PERMITIDO,
  LIMPA_FALLBACK_PERMITIDO,
  DEFINE_METADATA,
  JA_LISTOU_HORARIO
} from './types'
import { ATUALIZA_UNIDADE } from '../unidade/types'
import { ATUALIZA_LOCAL } from '../local/types'

const initialState: Consulta = {
  origemTeleconsulta: 'outro',
  estaConfirmada: false,
  localSugestoes: [],
  fallbacksPermitidos: [],
  metaData: {
    primeiraListagemHorarios: undefined,
    ultimaListagemHorarios: '',
    quantidadeListagemHorarios: 0
  },
  jaListouHorario: false
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function consultaReducer(state = initialState, action: any): Consulta {
  const dataAtual = new Date().toTimeString()

  switch (action.type) {
    case ATUALIZA_MEDICO:
      return {
        ...state,
        ultimoStepAtualizado: 'especialidade-medico',
        medico:
          typeof action.payload === 'undefined'
            ? undefined
            : { ...action.payload }
      }
    case ATUALIZA_ESPECIALIDADE:
      return {
        ...state,
        ultimoStepAtualizado: 'especialidade-medico',
        especialidade:
          typeof action.payload === 'undefined'
            ? undefined
            : { ...action.payload }
      }
    case ATUALIZA_PACIENTE:
      return {
        ...state,
        ultimoStepAtualizado: 'paciente',
        paciente:
          typeof action.payload === 'undefined'
            ? undefined
            : { ...action.payload }
      }
    case ATUALIZA_PAGAMENTO:
      return {
        ...state,
        ultimoStepAtualizado: 'pagamento',
        pagamento:
          typeof action.payload === 'undefined'
            ? undefined
            : { ...action.payload }
      }
    case ATUALIZA_HORARIO:
      return {
        ...state,
        ultimoStepAtualizado: 'agendar-consulta',
        horario:
          typeof action.payload === 'undefined'
            ? undefined
            : { ...action.payload }
      }
    case ATUALIZA_UNIDADE:
      return {
        ...state,
        ultimoStepAtualizado: 'agendar-consulta',
        unidade:
          typeof action.payload === 'undefined'
            ? undefined
            : { ...action.payload }
      }
    case ATUALIZA_ESCOLHA:
      return {
        ...state,
        ...action.payload,
        ultimoStepAtualizado: 'especialidade-medico'
      }
    case ATUALIZA_MODALIDADE_ATENDIMENTO:
      return {
        ...state,
        ...action.payload,
        ultimoStepAtualizado: 'especialidade-medico'
      }
    case ATUALIZA_NUMERO_REQUISICAO:
      return {
        ...state,
        numeroRequisicao: action.payload
      }
    case ATUALIZA_LOCAL:
      return {
        ...state,
        ultimoStepAtualizado: 'local',
        local:
          typeof action.payload === 'undefined'
            ? undefined
            : { ...action.payload }
      }
    case START_CONSULTA:
      return {
        ...state,
        ...action.payload,
        ultimoStepAtualizado: undefined
      }
    case LIMPA_CONSULTA:
      return {}

    case REINICIA_CONSULTA:
      return {
        especialidade: undefined,
        medico: undefined,
        escolhaPorEspecialidade: false,
        agendamentoTeleconsulta: false,
        agendamentoViaSite: false,
        escolhaPorMedico: false,
        local: undefined,
        paciente: undefined,
        pagamento: undefined,
        unidade: undefined,
        horario: undefined,
        ultimoStepAtualizado: 'especialidade-medico'
      }

    case ATUALIZA_CONFIRMACAO:
      return {
        ...state,
        estaConfirmada: action.payload
      }

    case ATUALIZA_ORIGEM_TELECONSULTA:
      return {
        ...state,
        origemTeleconsulta: action.payload
      }

    case ATUALIZA_LOCAL_SUGESTOES:
      return {
        ...state,
        localSugestoes: action.payload
      }

    case ATUALIZA_FALLBACK_PERMITIDO:
      return {
        ...state,
        fallbacksPermitidos: [action.payload]
      }

    case LIMPA_LOCAL_SUGESTOES:
      return {
        ...state,
        localSugestoes: []
      }

    case LIMPA_FALLBACK_PERMITIDO:
      return {
        ...state,
        fallbacksPermitidos: []
      }

    case DEFINE_METADATA:
      return {
        ...state,
        metaData: {
          primeiraListagemHorarios:
            typeof state.metaData?.primeiraListagemHorarios === 'undefined'
              ? dataAtual
              : state.metaData?.primeiraListagemHorarios,
          ultimaListagemHorarios: dataAtual,
          quantidadeListagemHorarios:
            typeof state.metaData?.quantidadeListagemHorarios === 'undefined'
              ? 1
              : state.metaData.quantidadeListagemHorarios + 1
        }
      }

    case JA_LISTOU_HORARIO:
      return {
        ...state,
        jaListouHorario: action.payload
      }

    default:
      return state
  }
}
